import { FC, ReactNode } from 'react';
import { Link } from '@heroui/react';

export const BottomBarItem: FC<{
  icon: (isActive?: boolean) => ReactNode;
  text?: string;
  href: string;
  isActive?: boolean;
}> = ({ icon, text, href, isActive = false }) => {
  return (
    <Link
      href={href}
      style={{ color: isActive ? '#006FEE' : '#9CA5AC' }}
      className="flex flex-col items-center justify-center p-1"
    >
      {icon(isActive)}
      <span className="text-[10px]">{text}</span>
    </Link>
  );
};
